import React, { useState } from "react";
import DataTable from "../../../../Components/Others/DataTable";
import {
  CancelButton,
  CreateButton,
  ExportButton,
  FilterButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation } from "react-router-dom";
import SearchBar from "../../../../Components/Utils/SearchBar";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import MoreOptions from "../../../../Components/Utils/MoreOptions";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import PremiumTable, { CopyButton } from "../../../../Components/Others/PremiumTable";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import { useEffect } from "react";
import { useDeleteData } from "../../../../Components/Hooks/useDeleteData";
import moment from "moment";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useFormik } from "formik";
import * as yup from "yup";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { NuDataTime, NuDate } from "../../../../Components/Utils/Input";
import NuAmount from "../../../../Components/Utils/NuAmount";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import MultiEditCQ from "./MultiEditCQ";
import {
  GetAccess,
  GetMultiNotUseRole,
  GetRole,
  GetUserDetail,
  CheckEditAction,
  CheckDeleteAction,
} from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import CloseIcon from "../../../../Components/Icons/Close";
import axiosInstance from "../../../../Services/axiosCommon";
import DataFormat from "../../../../Components/Utils/NuDate";
import ViewToggle from "../../../../Components/Utils/ViewToggle";

// Approval Status Icons
const HourglassIcon = () => (
  <svg className="w-4 h-4 text-amber-500 animate-pulse shrink-0" viewBox="0 0 384 512" fill="currentColor" title="Pending">
    <path d="M360 0H24C10.7 0 0 10.7 0 24v16c0 13.3 10.7 24 24 24h16v96c0 56.6 32.7 105.6 80 128-47.3 22.4-80 71.4-80 128v96H24c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24h-16v-96c0-56.6-32.7-105.6-80-128 47.3-22.4 80-71.4 80-128V64h16c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24zm-80 448H104v-48c0-44.1 35.9-80 80-80s80 35.9 80 80v48zm0-240v16H104v-16c0-44.1 35.9-80 80-80s80 35.9 80 80z" />
  </svg>
);
const ApprovedIcon = () => (
  <svg className="w-4 h-4 text-emerald-500 shrink-0" viewBox="0 0 512 512" fill="currentColor" title="Approved">
    <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm108.384 186.758l-140.2 140.2c-4.7 4.7-12.3 4.7-17 0l-71.8-71.8c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l46.3 46.3 114.7-114.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17z" />
  </svg>
);
const RejectedIcon = () => (
  <svg className="w-4 h-4 text-rose-500 shrink-0" viewBox="0 0 512 512" fill="currentColor" title="Rejected">
    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.6 65-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65z" />
  </svg>
);
const renderApprovalStatusIcon = (status) => {
  if (status === "Approved" || status === "Completed") return <ApprovedIcon />;
  if (status === "Rejected") return <RejectedIcon />;
  return <HourglassIcon />;
};

// Customer Quotation Table Row Component
const CustomerQuotationTableRow = ({
  row,
  isSelected,
  onSelect,
  canEdit,
  canDelete,
  handleDelete,
  pageIndex,
  searchQuery,
}) => {
  const formattedPrDate = row.prDate ? moment(row.prDate).format("DD-MMM-YYYY") : "--";
  const formattedDate = row.date ? moment(row.date).format("DD-MMM-YYYY") : "--";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/customer-quotations/" + `${row.id}`, setIsModalOpen);
  return (
    <>
      <tr className="bg-white hover:bg-white/80 transition-colors align-middle border-b border-gray-100">
        {/* Checkbox */}
        <td className="p-4 text-center align-middle border-t border-l border-gray-200/60 rounded-tl-xl rounded-bl-xl">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer"
          />
        </td>

        {/* YPR */}
        <td className="p-4 align-middle border-t border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
          <div className="flex items-center gap-1.5">
            <Link
              to={`/sales/quotes/view/${row.id}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="hover:underline text-sm font-bold text-gray-800"
            >
              {row.prRef || "N/A"}
            </Link>
            <CopyButton text={row.prRef} />
          </div>
        </td>

        {/* YPR Date */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
          {formattedPrDate}
        </td>

        {/* YPR Desc */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600 max-w-[200px] truncate">
          {row.prDesc || "--"}
        </td>

        {/* Quote No */}
        <td className="p-4 align-middle border-t border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
          <div className="flex items-center gap-1.5">
            <Link
              to={`/sales/quotes/view/${row.id}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="hover:underline text-sm font-bold text-gray-800"
            >
              {row.ref || "N/A"}
            </Link>
            <CopyButton text={row.ref} />
          </div>
        </td>

        {/* Date */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
          {formattedDate}
        </td>

        {/* Amount */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-bold text-gray-800">
          <NuAmount currency={row["vendorCurrency"] || row["currency"]} value={row.totalPrice || 0} />
        </td>

        {/* Customer */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600">
          {row.customerName || "N/A"}
        </td>

        {/* Sales Person */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600">
          {row.salesPerson || "N/A"}
        </td>

        {/* Status */}
        <td className="p-4 align-middle border-t border-gray-200/60 whitespace-nowrap">
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${row.status === "Approved" || row.status === "Completed"
            ? "bg-emerald-50 text-emerald-700 border-emerald-100"
            : row.status === "Pending"
              ? "bg-amber-50 text-amber-700 border-amber-100"
              : "bg-gray-50 text-gray-600 border-gray-100"
            }`}>
            {row.status || "N/A"}
          </span>
        </td>

        {/* Action Buttons */}
        <td className="p-4 text-center align-middle border-t border-r border-gray-200/60 rounded-tr-xl rounded-br-xl">
          <div className="flex items-center justify-center gap-1.5">
            {/* Approval Status Icon */}
            {renderApprovalStatusIcon(row.approvalStatus)}
            {/* View */}
            <Link
              to={`/sales/quotes/view/${row.id}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-blue-200 text-blue-600 hover:bg-blue-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="View details"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </Link>
            {/* Edit */}
            {CheckEditAction(row, "Customer Quotation", canEdit) && (
              <Link
                to={`/sales/quotes/edit/${row.id}/viewqoute`}
                state={{
                  data: row,
                  from: "/sales/quotes",
                  pageIndex: pageIndex,
                  searchQuery: searchQuery,
                }}
                className="border border-sky-200 text-[#0ea5e9] hover:bg-sky-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
                title="Edit Quote"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </Link>
            )}
            {/* Delete */}
            {CheckDeleteAction(row, canDelete) && (
              <button
                onClick={() => setIsModalOpen(true)}
                className="border border-red-200 text-red-500 hover:bg-red-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
                title="Delete Quote"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            )}
          </div>
        </td>
      </tr>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.ref} will be removed from Customer Quotations!`}
        handleClick={() => handleDelete("/customer-quotations/" + `${row.id}`, setIsModalOpen)}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

// Customer Quotation Card Component
const CustomerQuotationCard = ({
  row,
  isSelected,
  onSelect,
  canEdit,
  canDelete,
  handleDelete,
  pageIndex,
  searchQuery,
}) => {
  const formattedDate = row.date ? moment(row.date).format("DD-MMM-YYYY") : "--";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/customer-quotations/" + `${row.id}`, setIsModalOpen);
  return (
    <div className="relative border border-y-gray-200/50 border-r-gray-200/50 border-l-0 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] transition-all duration-300 rounded-2xl bg-white p-4 flex flex-col gap-4 overflow-hidden border-l-4 border-l-teal-500">
      {/* Card Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:gap-4">
        <div className="flex items-center gap-2.5">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer"
          />
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5">
              <Link
                to={`/sales/quotes/view/${row.id}`}
                state={{
                  data: row,
                  pageIndex: pageIndex,
                  searchQuery: searchQuery,
                }}
                className="text-gray-800 font-bold hover:underline text-sm"
              >
                {row.ref || "N/A"}
              </Link>
              <CopyButton text={row.ref} />
            </div>
            <div className="flex items-center gap-1 mt-0.5">
              <span className="text-[10px] text-gray-500 font-bold">YPR: {row.prRef || "N/A"}</span>
              <CopyButton text={row.prRef} />
            </div>
            <span className="text-[10px] text-gray-400 font-bold mt-0.5">Customer: {row.customerName || "N/A"}</span>
          </div>
        </div>

        {/* Approval Icon + Status Badge */}
        <div className="flex items-center gap-2">
          {renderApprovalStatusIcon(row.approvalStatus)}
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${row.status === "Approved" || row.status === "Completed"
            ? "bg-emerald-50 text-emerald-700 border-emerald-100"
            : row.status === "Pending"
              ? "bg-amber-50 text-amber-700 border-amber-100"
              : "bg-gray-50 text-gray-600 border-gray-100"
            }`}>
            {row.status || "N/A"}
          </span>
        </div>
      </div>

      {/* Middle Grid */}
      <div className="bg-[#FAFAFC]/60 rounded-xl p-3.5 border border-gray-100 flex justify-between items-center gap-2 text-xs">
        <div className="flex flex-col gap-0.5 flex-1">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Date</span>
          <span className="font-bold text-gray-700">{formattedDate}</span>
        </div>
        <div className="w-[1px] h-8 bg-gray-100" />
        <div className="flex flex-col gap-0.5 flex-1 pl-2">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Sales Person</span>
          <span className="font-bold text-gray-700 truncate block max-w-[100px]">{row.salesPerson || "N/A"}</span>
        </div>
      </div>

      {/* Amount details */}
      <div className="flex justify-between items-center px-1 text-xs text-gray-600 font-medium">
        <span>Total Amount:</span>
        <span className="font-extrabold text-gray-800 text-sm">
          <NuAmount currency={row["vendorCurrency"] || row["currency"]} value={row.totalPrice || 0} />
        </span>
      </div>

      {/* Action Buttons Row */}
      <div className="flex items-center justify-between border-t border-gray-100 pt-3 mt-1">
        <Link
          to={`/sales/quotes/view/${row.id}`}
          state={{
            data: row,
            pageIndex: pageIndex,
            searchQuery: searchQuery,
          }}
          className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
          title="View Details"
        >
          <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          <span className="hidden sm:inline">View Details</span>
        </Link>
        <div className="flex items-center gap-1.5">
          {CheckEditAction(row, "Customer Quotation", canEdit) && (
            <Link
              to={`/sales/quotes/edit/${row.id}/viewqoute`}
              state={{
                data: row,
                from: "/sales/quotes",
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-sky-100 text-[#0ea5e9] hover:bg-sky-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
              title="Edit"
            >
              <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              <span className="hidden sm:inline">Edit</span>
            </Link>
          )}
          {CheckDeleteAction(row, canDelete) && (
            <button
              onClick={() => setIsModalOpen(true)}
              className="border border-red-100 text-red-500 hover:bg-red-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
              title="Delete"
            >
              <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              <span className="hidden sm:inline">Delete</span>
            </button>
          )}
        </div>
      </div>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.ref} will be removed from Customer Quotations!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </div>
  );
};

function CustomerQuotationIndex() {
  const location = useLocation();
  const state = location.state;

  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20,
  );
  const [filter, setFilter] = useState(state?.approvalStatus ? true : false);

  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [showExport, setShowExport] = useState(false);

  const { name, role, id } = GetUserDetail();
  const isSalesman = role === "sales man" || role === "sales";
  console.log("isSalesman", isSalesman);
  console.log("role", role, name);

  const { value: Availablity } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Availablity_CustomerQuotes",
  );
  // const { value: DeliveryTerm } = useFetchMataData(
  //   `/dropdown/dropdown-details/`,
  //   "DeliveryTerm_CustomerQuotes"
  // );
  // const { value: PaymentTerms } = useFetchMataData(
  //   `/dropdown/dropdown-details/`,
  //   "PaymentTerms_CustomerQuotes"
  // );
  const { value: DeliveryTerm, getData: refDeliveryTerms } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "DeliveryTerms_Supplierqoutes",
    showFilterDialog || showExport,
  );
  const { value: PaymentTerms, getData: refPaymentTerms } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "PaymentTerms_Supplierqoutes",
    showFilterDialog || showExport,
  );
  const { value: PaymentMethod } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "PaymentMethod_CustomerQuotes",
    showFilterDialog || showExport,
  );
  // const { value: Validity } = useFetchMDIndex(
  //   `/dropdown/dropdown-details/`,
  //   "Validity_CustomerQuotes"
  // ,showFilterDialog);
  const { value: Validity, getData: refValidity } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Validity_Supplierquotes",
    showFilterDialog || showExport,
  );
  const { value: status } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Status_customerQuotes",
    showFilterDialog || showExport,
  );
  const { value: leadTime } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "leadTime_customerQuotes",
    showFilterDialog || showExport,
  );
  const { data: Salesman } = UseDropDown("/user/salesman/drop-down");

  const [filterProps, setFilterProps] = useState({
    status: "",
    paymentMethod: "",
    leadTime: "",
    validity: "",
    availability: "",
    approvalStatus: "",
    paymentTerms: "",
    deliveryTerms: "",
    fromDate: "",
    toDate: "",
    salesPerson: isSalesman ? id : "",
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    status: "",
    paymentMethod: "",
    leadTime: "",
    validity: "",
    availability: "",
    approvalStatus: state?.approvalStatus ? state.approvalStatus : "",
    paymentTerms: "",
    deliveryTerms: "",
    fromDate: "",
    toDate: "",
    salesPerson: isSalesman ? id : "",
  });
  const clearFilter = () => {
    setParams({
      ...params,
      status: "",
      paymentMethod: "",
      leadTime: "",
      validity: "",
      availability: "",
      approvalStatus: "",
      paymentTerms: "",
      deliveryTerms: "",
      fromDate: "",
      toDate: "",
      salesPerson: isSalesman ? id : "",
    });
    formik.values.status = "";
    formik.values.paymentMethod = "";
    formik.values.leadTime = "";
    formik.values.validity = "";
    formik.values.availability = "";
    formik.values.approvalStatus = "";

    formik.values.deliveryTerms = "";
    formik.values.fromDate = "";
    formik.values.toDate = "";
    formik.values.paymentTerms = "";
    formik.values.salesPerson = isSalesman ? id : "";

    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({
        ...params,
        paymentTerms: value.paymentTerms,
        toDate: value.toDate,
        salesPerson: isSalesman ? id : value.salesPerson,

        fromDate: value.fromDate,
        deliveryTerms: value.deliveryTerms,
        availability: value.availability,
        approvalStatus: value.approvalStatus,

        validity: value.validity,
        leadTime: value.leadTime,
        paymentMethod: value.paymentMethod,
        status: value.status,
      });
      closeFilterDialog();
      setFilter(true);
      setFilterProps({
        status: "",
        paymentMethod: "",
        leadTime: "",
        validity: "",
        availability: "",
        approvalStatus: "",
        paymentTerms: "",
        deliveryTerms: "",
        fromDate: "",
        toDate: "",
        salesPerson: isSalesman ? id : "",
      });
    },
  });

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch(
    "/customer-quotations/",
    params,
  );

  const defaultHeaders = [
    // {
    //   title: "ID",
    //   width: "5%",
    //   field: "id",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "YPR",
      width: "10%",
      isLink: true,
      id: "id",
      link: "/sales/quotes/view/",
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "YPR Date",
      width: "10%",
      field: "prDate",
      type: "date",
      isLink: true,
      id: "id",
      link: "/sales/quotes/view/",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "YPR Desc.",
      width: "10%",
      field: "prDesc",
      isLink: true,
      id: "id",
      link: "/sales/quotes/view/",
      textAlign: "center",
      rowAlign: "center",
      cellClass: "line-clamp-2",
    },
    {
      title: "Quote No.",
      width: "10%",
      isLink: true,
      id: "id",
      link: "/sales/quotes/view/",
      field: "ref",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Date",
      width: "10%",
      field: "date",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Amount",
      width: "10%",
      type: "amount",
      field: "totalPrice",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Customer",
      width: "10%",
      field: "customerName",
      textAlign: "center",
      rowAlign: "center",
    },
    // {
    //   title: "Days Taken",
    //   width: "10%",
    //   field: "totalPrice",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Sales Person",
      width: "10%",
      field: "salesPerson",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "id",
        removeValue: "ref",
        url: `/customer-quotations/`,
        moduleName: "Customer Quotations",
        from: `/sales/quotes`,
        editLink: "/sales/quotes/edit/{id}/viewqoute",
        viewLink: "/sales/quotes/view/",
        // EmailRequired: true,
        // emailType: true
      },
    },
  ];
  const availableHeaders = [
    // {
    //   title: "ID",
    //   width: "5%",
    //   field: "id",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "YPR",
      width: "10%",
      isLink: true,
      id: "id",
      link: "/sales/quotes/view/",
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "YPR Date",
      width: "10%",
      field: "prDate",
      type: "date",
      isLink: true,
      id: "id",
      link: "/sales/quotes/view/",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "YPR Desc.",
      width: "10%",
      field: "prDesc",
      isLink: true,
      id: "id",
      link: "/sales/quotes/view/",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Quote No.",
      width: "10%",
      isLink: true,
      id: "id",
      link: "/sales/quotes/view/",
      field: "ref",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Date",
      width: "10%",
      field: "date",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Amount",
      width: "10%",
      type: "amount",
      field: "totalPrice",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Customer",
      width: "10%",
      field: "customerName",
      textAlign: "center",
      rowAlign: "center",
    },
    // {
    //   title: "Days Taken",
    //   width: "10%",
    //   field: "totalPrice",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Sales Person",
      width: "10%",
      field: "salesPerson",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Payment Terms",
      width: "10%",
      field: "paymentTerms",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Delivery Terms",
      width: "10%",
      field: "deliveryTerms",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Validity",
      width: "10%",
      field: "validity",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Approved By ",
      width: "10%",
      field: "approvedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Prepared By ",
      width: "10%",
      field: "preparedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Reviewed By ",
      width: "10%",
      field: "reviewedByName",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "id",
        removeValue: "ref",
        url: `/customer-quotations/`,
        moduleName: "Customer Quotations",
        from: `/sales/quotes`,
        editLink: "/sales/quotes/edit/{id}/viewqoute",
        viewLink: "/sales/quotes/view/",
        // EmailRequired: true,
        // emailType: true
      },
    },
  ];

  const [viewMode, setViewMode] = useState(localStorage.getItem("customerQuotationViewMode") || "table");

  useEffect(() => {
    localStorage.setItem("customerQuotationViewMode", viewMode);
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount, viewMode]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  const closeFilterDialogebox = () => {
    setShowExport(false);
  };

  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const canEdit = GetAccess("customer_quote_edit") || GetRole();
  const canDelete = GetAccess("customer_quote_delete") || GetRole();
  const { handle: handleDelete } = useDeleteData(getData);

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
  };

  const selectMultipleFunction = (e) => {
    console.log(e.target.checked);
    if (e.target.checked) {
      setListofNumbers(fullList);
    } else {
      setListofNumbers([]);
    }
  };

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        console.log("I", i?.id);
        tempArr.push(i?.id);
      });
    setFullList(tempArr);
  }, [data]);

  const [exportValue, setExportValue] = useState({
    type: "all",
    approvalStatus: "",
    salesPerson: isSalesman ? id : "",
    status: "",
    leadTime: "",
    validity: "",
    availability: "",
    paymentMethod: "",
    paymentTerms: "",
    deliveryTerms: "",
    fromDate: "",
    toDate: "",
  });
  const ExportFormik = useFormik({
    enableReinitialize: true,
    initialValues: exportValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      try {
        const response = await axiosInstance.get(
          `/customer-quotations/export-to-excel?approvalStatus=${value.approvalStatus}&salesPerson=${isSalesman ? id : value.salesPerson}&status=${value.status}&leadTime=${value.leadTime}&validity=${value.validity}&availability=${value.availability}&paymentMethod=${value.paymentMethod}&paymentTerms=${value.paymentTerms}&deliveryTerms=${value.deliveryTerms}&fromDate=${value.fromDate}&toDate=${value.toDate}`,
          {
            responseType: "blob", // Important to specify the response type as blob
          },
        );

        // Create a Blob from the response
        const pdfBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a link element

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(pdfBlob);
        link.download = `CQ Report ${DataFormat({ value: new Date(), format: "DD-MMM-YYYY" })}.xlsx`; // The filename you want for the downloaded file

        // Append the link to the body (required for Firefox)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      } catch (error) {
        console.error("Error downloading the PDF:", error);
      }
    },
  });

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 1024 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobile ? "card" : (viewMode === "list" ? "table" : viewMode);

  return (
    <div className="w-full h-full lg:px-4 p-2">
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb
            items={[{ name: "Sales" }, { name: "Customer Quotation" }]}
          />
          <div className="flex md:hidden items-center gap-1.5 flex-wrp">
            {GetRole() && (
              <ExportButton handleClick={() => setShowExport(true)} />
            )}
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
            {GetAccess("customer_quote_create") && (
              <Link to="/sales/quotes/create/viewqoutes">
                <CreateButton label="Quote" />
              </Link>
            )}
          </div>
        </div>

        <div className="w-full md:w-auto flex flex-wrap md:flex-nowrap items-center justify-between md:justify-start gap-2">
          <div className="w-full md:w-auto flex-1 min-w-0">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1);
              }}
              value={params.search}
            />
          </div>

          <div className="hidden md:flex items-center gap-2">
            <ViewToggle
              viewMode={effectiveViewMode}
              onViewChange={(mode) => setViewMode(mode)}
              storageKey="customerQuotationViewMode"
            />
            {GetRole() && (
              <ExportButton handleClick={() => setShowExport(true)} />
            )}

            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}

            {GetAccess("customer_quote_create") && (
              <Link to="/sales/quotes/create/viewqoutes">
                <CreateButton label="Quote" />
              </Link>
            )}
          </div>
        </div>
      </div>

      <PremiumTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        viewMode={effectiveViewMode}
        headers={[
          { title: "YPR", width: "150px" },
          { title: "YPR Date", width: "130px" },
          { title: "YPR Desc.", width: "auto" },
          { title: "Quote No.", width: "150px" },
          { title: "Date", width: "120px" },
          { title: "Amount", width: "150px" },
          { title: "Customer", width: "180px" },
          { title: "Sales Person", width: "160px" },
          { title: "Status", width: "120px" },
          { title: "Action", align: "center", width: "130px" }
        ]}
        renderRow={(row, idx) => (
          <CustomerQuotationTableRow
            row={row}
            isSelected={listofNumbers.includes(row.id)}
            onSelect={() => selectOneFunction(row.id)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
          />
        )}
        renderCard={(row, idx) => (
          <CustomerQuotationCard
            row={row}
            isSelected={listofNumbers.includes(row.id)}
            onSelect={() => selectOneFunction(row.id)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
          />
        )}
        dataLoading={dataLoading}
        listofNumbers={listofNumbers}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
      />
      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-full sm:w-[520px] max-w-[95vw] max-h-[90vh] bg-white py-4 px-4 sm:px-6 rounded-xl shadow-lg overflow-y-auto">
            <h2 className="text-lg font-bold text-gray-800 mb-4">Filter Customer Quotation</h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col gap-3 mb-4">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Date</p>
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full">
                  <NuDate
                    label="From"
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="fromDate"
                    width="w-full"
                  />
                  <NuDate
                    label="To"
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="toDate"
                    width="w-full"
                  />
                </div>
                <FormikSelectTwo
                  type="text"
                  label="Delivery Terms"
                  placeholder="Choose"
                  Options={DeliveryTerm}
                  formik={formik}
                  name="deliveryTerms"
                  width="w-full"
                />
                <FormikSelectTwo
                  type="text"
                  label="Payment Terms"
                  placeholder="Choose"
                  Options={PaymentTerms}
                  formik={formik}
                  name="paymentTerms"
                  width="w-full"
                />

                <FormikSelectTwo
                  type="text"
                  label="Product Availability"
                  placeholder="Choose"
                  Options={Availablity}
                  formik={formik}
                  name="availability"
                  width="w-full"
                />
                <FormikSelectTwo
                  type="text"
                  label="Quotation Validity"
                  placeholder="Choose"
                  Options={Validity}
                  formik={formik}
                  name="validity"
                  width="w-full"
                />
                {GetMultiNotUseRole(["sales man", "sales"]) && (
                  <FormikSelectTwo
                    type="text"
                    label="Sales Person"
                    placeholder="Choose"
                    Options={Salesman}
                    formik={formik}
                    name="salesPerson"
                    width="w-full"
                  />
                )}
                <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Choose"
                  Options={status}
                  formik={formik}
                  name="status"
                  width="w-full"
                />
                <FormikSelectTwo
                  type="text"
                  label="Approval Status"
                  placeholder="Approval Status"
                  Options={[
                    {
                      value: "Pending",
                      label: "Pending",
                    },
                    {
                      value: "Verified",
                      label: "Verified",
                    },
                    {
                      value: "Approved",
                      label: "Approved",
                    },
                  ]}
                  formik={formik}
                  name="approvalStatus"
                  width="w-full"
                />
              </div>
              <div className="flex justify-end gap-3 pt-3 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
      {showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-full sm:w-[500px] max-w-[95vw] max-h-[90vh] relative bg-white py-4 px-4 sm:px-6 rounded-xl shadow-lg overflow-y-auto">
            <div className="w-full flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
              <h2 className="text-base font-bold text-gray-800">
                Export Data
              </h2>
              <div
                className="cursor-pointer text-gray-400 hover:text-gray-600 transition-colors"
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className="w-full flex flex-col gap-3">
                <div className="w-full flex items-center gap-6 py-2 border-b border-gray-100">
                  <div className="flex items-center gap-2">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-[#048178] focus:ring-[#048178] border-gray-300 cursor-pointer"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="text-xs sm:text-sm font-semibold text-gray-700 cursor-pointer"
                    >
                      All Data
                    </label>
                  </div>

                  <div className="flex items-center gap-2">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-[#048178] focus:ring-[#048178] border-gray-300 cursor-pointer"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="text-xs sm:text-sm font-semibold text-gray-700 cursor-pointer"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <div className="flex flex-wrap gap-y-3">
                    <NuDate
                      label="From"
                      placeholder="dd/mm/yyyy"
                      formik={ExportFormik}
                      name="fromDate"
                      width="w-full sm:w-1/2"
                    />
                    <NuDate
                      label="To"
                      placeholder="dd/mm/yyyy"
                      formik={ExportFormik}
                      name="toDate"
                      width="w-full sm:w-1/2"
                    />

                    <FormikSelectTwo
                      type="text"
                      label="Sales Person"
                      placeholder="Choose"
                      Options={Salesman}
                      formik={ExportFormik}
                      name="salesPerson"
                      width="w-full sm:w-1/2"
                    />

                    <FormikSelectTwo
                      type="text"
                      label="Approval Status"
                      placeholder="Approval Status"
                      Options={[
                        {
                          value: "Pending",
                          label: "Pending",
                        },
                        {
                          value: "Verified",
                          label: "Verified",
                        },
                        {
                          value: "Approved",
                          label: "Approved",
                        },
                      ]}
                      formik={ExportFormik}
                      name="approvalStatus"
                      width="w-full sm:w-1/2"
                    />

                    <FormikSelectTwo
                      type="text"
                      label="Status"
                      placeholder="Choose"
                      Options={status}
                      formik={ExportFormik}
                      name="status"
                      width="w-full sm:w-1/2"
                    />

                    <FormikSelectTwo
                      type="text"
                      label="Delivery Terms"
                      placeholder="Choose"
                      Options={DeliveryTerm}
                      formik={ExportFormik}
                      name="deliveryTerms"
                      width="w-full sm:w-1/2"
                    />
                    <FormikSelectTwo
                      type="text"
                      label="Payment Terms"
                      placeholder="Choose"
                      Options={PaymentTerms}
                      formik={ExportFormik}
                      name="paymentTerms"
                      width="w-full sm:w-1/2"
                    />

                    <FormikSelectTwo
                      label="Payment Method"
                      placeholder="Choose"
                      Options={PaymentMethod}
                      formik={ExportFormik}
                      name="paymentMethod"
                      width="w-full sm:w-1/2"
                    />
                    <FormikSelectTwo
                      type="text"
                      label="Product Availability"
                      placeholder="Choose"
                      Options={Availablity}
                      formik={ExportFormik}
                      name="availability"
                      width="w-full sm:w-1/2"
                    />
                    <FormikSelectTwo
                      type="text"
                      label="Quotation Validity"
                      placeholder="Choose"
                      Options={Validity}
                      formik={ExportFormik}
                      name="validity"
                      width="w-full sm:w-1/2"
                    />
                  </div>
                )}
                <div className="flex w-full justify-end gap-3 pt-4 border-t border-gray-100 mt-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                  <SubmitButton name="Export" />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
      {showEdit && (
        <MultiEditCQ
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => { }}
        closeModal={() => setShowDelete(false)}
      />
    </div>
  );
}

export default CustomerQuotationIndex;
